var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6545 31.4856C18.6545 32.5856 19.5545 33.4856 20.6545 33.4856H28.6545C29.7545 33.4856 30.6545 32.5856 30.6545 31.4856V21.4856C30.6545 20.3856 29.7545 19.4856 28.6545 19.4856H20.6545C19.5545 19.4856 18.6545 20.3856 18.6545 21.4856V31.4856ZM30.6545 16.4856H28.1545L27.4445 15.7756C27.2645 15.5956 27.0045 15.4856 26.7445 15.4856H22.5645C22.3045 15.4856 22.0445 15.5956 21.8645 15.7756L21.1545 16.4856H18.6545C18.1045 16.4856 17.6545 16.9356 17.6545 17.4856C17.6545 18.0356 18.1045 18.4856 18.6545 18.4856H30.6545C31.2045 18.4856 31.6545 18.0356 31.6545 17.4856C31.6545 16.9356 31.2045 16.4856 30.6545 16.4856Z",
    fill: "#1A1C1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12.6545 12.4856)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3dbea76127e25d7043d98b8c9a21bc27.svg";
export { ForwardRef as ReactComponent };